export default {"src":"/_next/static/media/fraisreservations.4e567abc.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};